module.exports = __webpack_public_path__ + "media/images/undraw/resume_folder-ba91d78f3810676714b982c662fb7b54.png";